import React from 'react';
import { Select } from 'antd';
import Icon from '@mdi/react';

import {
  mdiEqual,
  mdiGreaterThan,
  mdiLessThan,
  mdiGreaterThanOrEqual,
  mdiLessThanOrEqual,
  mdiNotEqual,
} from '@mdi/js';

const operatorMap = {
  '=': { name: 'Equals', color: 'blue', icon: mdiEqual },
  '>': { name: 'Greater Than', color: 'green', icon: mdiGreaterThan },
  '<': { name: 'Less Than', color: 'red', icon: mdiLessThan },
  '>=': { name: 'Greater or Equal', color: 'cyan', icon: mdiGreaterThanOrEqual },
  '<=': { name: 'Less or Equal', color: 'orange', icon: mdiLessThanOrEqual },
  '!=': { name: 'Not Equal', color: 'magenta', icon: mdiNotEqual },
};

const SymbolsSelect = ({ value, onChange, ...rest }) => {
  const { Option } = Select;

  return (
    <Select
      name='operator'
      placeholder='Operator'
      dropdownStyle={{ width: 150 }}
      optionLabelProp='label'
      value={value}
      onChange={onChange}
      {...rest}
    >
      {Object.entries(operatorMap).map(([key, { name, icon }]) => (
        <Option key={key} value={key} label={name}>
          <div className='flex items-center gap-2'>
            <Icon path={icon} size={0.7} />
            <span>{name}</span>
          </div>
        </Option>
      ))}
    </Select>
  );
};

export default SymbolsSelect;
